export function formatDate(date) {
    let splitDate = date.split('-')
    return `${splitDate[0].slice(0,3).toUpperCase()} ${splitDate[1]}, ${splitDate[2]}`
}